import type { Country } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { CountryOfResidenceSelect } from "./CountryOfResidenceSelect"
import styles from "./PublicPageCountryOfResidenceSelect.module.scss"
import { useCountrySelectionContext } from "src/contexts"

export function PublicPageCountryOfResidenceSelect() {
  const {
    countryCode,
    setCountryCode,
  } = useCountrySelectionContext()

  const onCountryChange = useCallback(
    (newCountry?: Country) => {
      setCountryCode(newCountry?.country_code ?? "")
    },
    [setCountryCode],
  )

  return (
    <CountryOfResidenceSelect
      className={styles.countrySelect}
      value={countryCode}
      onChange={onCountryChange}
    />
  )
}
